import { Component, OnInit, Input } from "@angular/core";
import { MatDrawer } from "@angular/material/sidenav";
import { Select, Store } from "@ngxs/store";
import { UserState } from "src/app/states/user.state";
import { SignOut, CleanSelectedPlace } from "../../states/actions/user.actions";
import { Location } from "@angular/common";
import { filter, Observable } from "rxjs";
import { Place, Me, Submodule } from "src/app/interface/user";
import { imgErrorFallback } from "src/app/helpers/helpers";
import { NavigationEnd, Router } from "@angular/router";
import { DataService } from "src/app/services/data.service";
import {
  GetAllCoins,
  UpdateDefaultCashierCoin,
} from "src/app/states/actions/admin.actions";

@Component({
  selector: "app-toolbar",
  templateUrl: "./toolbar.component.html",
  styleUrls: ["./toolbar.component.scss"],
})
export class ToolbarComponent implements OnInit {
  @Input() drawer: MatDrawer;
  @Select(UserState.DeliveryRole) deliveryRole: Observable<any>;
  @Select(UserState.selectedPlace) selectedPlace: Observable<Place>;
  @Select(UserState.submodules) submodules: Observable<Submodule[]>;
  @Select(UserState.sudo) sudo: Observable<boolean>;
  @Select(UserState.me) me: Observable<Me>;

  title = "";
  icon: "";
  items = [
    {
      label: "Bodegas",
      value: "/admin/cellar",
      icon: "store",
    },
    {
      label: "Inventarios",
      value: "/admin/inventory/:id",
      icon: "store",
    },
    {
      label: "Marcas",
      value: "/admin/product/:id/:id",
      icon: "store",
    },
    { label: "Artículos", value: "/admin/features/:id", icon: "store" },
    {
      label: "Dashboard",
      value: "/admin",
      icon: "dashboard",
    },
    {
      label: "Clientes",
      value: "/reports/user",
      icon: "people",
    },
    {
      icon: "location_on",
      value: "/admin/place-profile",
      label: "Perfil de la tienda",
    },
    {
      label: "Órdenes",
      value: "/admin/orders/pending",
      icon: "assignment_turned_in",
    },
    {
      label: "Preparar orden",
      value: "/admin/orders/prepare/:id",
      icon: "assignment_turned_in",
    },
    {
      value: "/admin/gallery",
      icon: "collections",
      label: "Galería",
    },
    {
      value: "/reports",
      icon: "insert_chart",
      label: "Reportes",
    },
    {
      value: "/admin/blackBox",
      icon: "inventory_2",
      label: "Caja Negra",
    },
    {
      value: "/admin/billing/bills",
      icon: "receipt",
      label: "Facturación",
    },
    {
      value: "/admin/billing/bills?id=:id",
      icon: "receipt",
      label: "Facturación",
    },
    {
      value: "/admin/profile",
      icon: "person",
      label: "Perfil",
    },
    {
      icon: "widgets",
      value: "/admin/tags",
      label: "Categorias",
    },
    {
      icon: "prson",
      value: "/admin/users",
      label: "Administradores",
    },
    {
      icon: "person",
      value: "/admin/permissions",
      label: "Permisos",
    },
    {
      icon: "person",
      value: "/admin/add-user",
      label: "Agregar Usuario",
    },
    {
      icon: "request_quote",
      value: "/admin/billing-profile-place",
      label: "Perfil de facturación",
    },
  ];

  constructor(
    private _location: Location,
    private store: Store,
    private router: Router,
    private _dataService: DataService
  ) {}

  ngOnInit() {
    this.store.dispatch(new GetAllCoins());
    this.store.dispatch(new UpdateDefaultCashierCoin());

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const route = this.findRoute(event.urlAfterRedirects);
        if (route) {
          this.title = route.label;
          this.icon = route.icon;
        } else {
          this.title = "";
          this.icon = "";
        }
      });
  }

  goBack = () => {
    this._location.back();
  };

  logout = () => {
    this.store.dispatch(new SignOut());
  };

  cleanSelectedPlace = () => {
    this._dataService.displayLoading();
    this.store.dispatch(new CleanSelectedPlace()).subscribe({
      next: () => this._dataService.displayLoading(false),
      error: () => this._dataService.displayLoading(false),
    });
  };

  onError = imgErrorFallback;

  private findRoute(url: string): any {
    for (const item of this.items) {
      const regex = new RegExp(`^${item?.value?.replace(/:id/g, "[^/]+")}$`);
      if (regex.test(url)) {
        return item;
      }
    }
    return null;
  }
}
